import { useMemo } from 'react'
import { getParser } from 'bowser'

/**
 * 브라우저, OS 등 가져오기
 */
export const useDetectDevice = () => {
  return useMemo(() => {
    if (typeof window === 'undefined') {
      return {}
    }

    const parser = getParser(window.navigator.userAgent)

    return {
      isMobile: parser.getPlatform().type === 'mobile',
      isTablet: parser.getPlatform().type === 'tablet',
      isDesktop: parser.getPlatform().type === 'desktop',
      isAndroid: parser.getOS().name === 'Android',
      isIOS: parser.getOS().name === 'iOS',
      isWindows: parser.getOS().name === 'Windows',
      isMac: parser.getOS().name === 'macOS',
    }
  }, [])
}
